var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},[_c('IntroductionBackground'),_c('IntroductionHeader'),_c('div',{class:_vm.$style.content},[_c(_vm.component,{tag:"component"})],1),_c('IntroductionFooter',{attrs:{"step":_vm.step},on:{"next":_vm.next,"finish":_vm.finish}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }